import { DashboardConstants, documentationActions } from './constant';

const {
  GET_DASHBOARD_PATIENT_LIST_REQUEST,
  GET_TODAY_PATIENT_LIST_REQUEST,
  GET_TODAY_PATIENT_LIST_RESET,
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET,
  GET_DASHBOARD_OVERVIEW_REQUEST,
  GET_DASHBOARD_DOCUMENTATION_REQUEST,
  GET_DASHBOARD_THERAPY_REQUEST,
  GET_DASHBOARD_TIME_IN_REQUEST,
  POST_DASHBOARD_CHECKOUT_REQUEST,
  POST_DASHBOARD_CHECKOUT_RESET,
  GET_DASHBOARD_TIME_IN_RESET,
  RESET_HARD_CLOCK_IN,
  GET_DASHBOARD_PATIENT_DETAILS_RESET,
  POST_DASHBOARD_CHECKOUT_RESET_LOGOUT,
  GET_DASHBOARD_PATIENT_DETAILS_REQUEST,
  POST_CHECKOUT_ACTION_RESET,
  GET_DASHBOARD_PTO_UPDATE_REQUEST,
  GET_INTERVENTION_GROUP_REQUEST,
  GET_GAME_BY_INTERVENTION_REQUEST,
  GET_AUTO_CLOCK_OUT_CALL_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_RESET,
  GET_THERAPIST_DAILY_UPDATES_REQUEST,
  GET_DASHBOARD_SUPERVISOR_EDIT_REQUEST,
  GET_OTHER_DASHBOARD_DOCUMENT_REQUEST,
  GET_OTHER_DASHBOARD_DOCUMENT_RESET,
  GET_MY_DASHBOARD_DOCUMENT_REQUEST,
  GET_MY_DASHBOARD_DOCUMENT_RESET,
  CO_SIGNATURE_REVIEW_REQUEST,
  CO_SIGNATURE_REVIEW_RESET,
  APPLY_THERAPIST_BULK_SIGNATURE_REQUEST,
  APPLY_THERAPIST_BULK_SIGNATURE_RESET,
  GET_DSN_SUMMARY_REQUEST,
  GET_DSN_SUMMARY_RESET,
} = DashboardConstants;
const { DASHBOARD_SIGNATURE_TEMPLATE, DASHBOARD_DOC_PREVIEW } = documentationActions;

export const getTherapistDashboardPatientList = (payload: any) => {
  return {
    type: GET_DASHBOARD_PATIENT_LIST_REQUEST,
    payload,
  };
};

export const getTodayPatientListAction = (payload: any) => {
  return {
    type: GET_TODAY_PATIENT_LIST_REQUEST,
    payload,
  };
};

export const resetTodayPatientListAction = () => {
  return {
    type: GET_TODAY_PATIENT_LIST_RESET,
  };
};

export const getAllTodaysDocumentAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST,
    payload,
  };
};
export const getAllTodaysDocumentCSVAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST,
    payload,
  };
};

export const getAllTodaysDocumentCSVRestAction = () => {
  return {
    type: GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET,
  };
};

export const getAllTaskOverview = (payload: any) => {
  return {
    type: GET_DASHBOARD_OVERVIEW_REQUEST,
    payload,
  };
};
export const getAllTherapyOverview = (payload: any) => {
  return {
    type: GET_DASHBOARD_THERAPY_REQUEST,
    payload,
  };
};
export const getAllDocumentationOverview = (payload: any) => {
  return {
    type: GET_DASHBOARD_DOCUMENTATION_REQUEST,
    payload,
  };
};

//time check in out

export const getTimeCheckInAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_TIME_IN_REQUEST,
    payload,
  };
};

export const postTimeCheckOutAction = (payload: any) => {
  return {
    type: POST_DASHBOARD_CHECKOUT_REQUEST,
    payload,
  };
};

export const postTimeCheckOutActionResetLogout = () => {
  return {
    type: POST_DASHBOARD_CHECKOUT_RESET_LOGOUT,
  };
};

//action reset

export const postCheckInOutActionReset = () => {
  return {
    type: POST_CHECKOUT_ACTION_RESET,
  };
};

export const postTimeCheckOutActionReset = () => {
  return {
    type: POST_DASHBOARD_CHECKOUT_RESET,
  };
};

export const getTimeCheckInActionReset = () => {
  return {
    type: GET_DASHBOARD_TIME_IN_RESET,
  };
};
export const resetHardClockIn = () => {
  return {
    type: RESET_HARD_CLOCK_IN,
  };
};

export const getDashboardPatientInfoAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_PATIENT_DETAILS_REQUEST,
    payload,
  };
};

export const viewSignatureDashboardDoc = (payload: any) => {
  return {
    type: DASHBOARD_SIGNATURE_TEMPLATE,
    payload,
  };
};

export const previewDashboardDoc = (payload: any) => {
  return {
    type: DASHBOARD_DOC_PREVIEW,
    payload,
  };
};

export const getLatestPtoUpdates = (payload: any) => {
  return {
    type: GET_DASHBOARD_PTO_UPDATE_REQUEST,
    payload,
  };
};

//get intervention

export const getInterventionGroupAction = (payload: any) => {
  return {
    type: GET_INTERVENTION_GROUP_REQUEST,
    payload,
  };
};

//get games by intervention

export const getGamesByIntervention = (payload: any) => {
  return {
    type: GET_GAME_BY_INTERVENTION_REQUEST,
    payload,
  };
};

export const callAutoClockOutAction = (payload: any) => {
  return {
    type: GET_AUTO_CLOCK_OUT_CALL_REQUEST,
    payload,
  };
};

export const resetDashboardSubmittedDoc = () => {
  return {
    type: GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_RESET,
  };
};

export const getTherapistDailyUpdatesAction = (payload: any) => {
  return {
    type: GET_THERAPIST_DAILY_UPDATES_REQUEST,
    payload,
  };
};

export const getDashboardSupervisorEditAction = () => {
  return {
    type: GET_DASHBOARD_SUPERVISOR_EDIT_REQUEST,
  };
};

export const getAllOtherDashboardDocuments = (payload: any) => {
  return {
    type: GET_OTHER_DASHBOARD_DOCUMENT_REQUEST,
    payload,
  };
};

export const resetAllOtherDashboardDocuments = () => {
  return {
    type: GET_OTHER_DASHBOARD_DOCUMENT_RESET,
  };
};

export const getMyOtherDashboardDocuments = (payload: any) => {
  return {
    type: GET_MY_DASHBOARD_DOCUMENT_REQUEST,
    payload,
  };
};

export const resetAllMyDashboardDocuments = () => {
  return {
    type: GET_MY_DASHBOARD_DOCUMENT_RESET,
  };
};

export const updateCoSignatureStatus = (payload: any) => {
  return {
    type: CO_SIGNATURE_REVIEW_REQUEST,
    payload,
  };
};

export const resetCoSignatureStatus = () => {
  return {
    type: CO_SIGNATURE_REVIEW_RESET,
  };
};

export const applyBulkSignatureRequest = (payload: any) => {
  return {
    type: APPLY_THERAPIST_BULK_SIGNATURE_REQUEST,
    payload,
  };
};

export const applyBulkSignatureReset = () => {
  return {
    type: APPLY_THERAPIST_BULK_SIGNATURE_RESET,
  };
};

export const getDSNNoteSummary = (payload: any) => {
  return {
    type: GET_DSN_SUMMARY_REQUEST,
    payload,
  };
};

export const resetDsnSummary = () => {
  return {
    type: GET_DSN_SUMMARY_RESET,
  };
};
